module.exports = "<ng-container *ngIf=\"agenda\">\n\t<app-settimana-style [settimana]=\"agenda.ambulatorio\"></app-settimana-style>\n\t<ng-container *ngIf=\"agenda.alternativa | async; let alternativa\">\n\t\t<ng-container *ngFor=\"let settimana of alternativa\">\n\t\t\t<app-settimana-style [settimana]=\"settimana\"></app-settimana-style>\t\t\n\t\t</ng-container>\n\t</ng-container>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/app/calendar/calendar-style/calendar-style.component.html
// module id = ./src/app/calendar/calendar-style/calendar-style.component.html
// module chunks = main